<template>
  <page-view :title="$t(`library.${type}`)" backLink="/broadcasts" backText="Back to Broadcasts" :key="$route.hash">
    <template v-slot:header-right>
      <Button @click="$router.push('/broadcast/schedule')" :disabled="disableNewBroadcast">{{ $t('library.newbroadcast') }}</Button>
    </template>
    <broadcast-list
      :status="type"
      :compact="true"
    />
  </page-view>
</template>

<script>

import BroadcastList from '@/components/Broadcast/List.vue';

export default {
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['upcoming', 'past', 'all', 'abandoned'].indexOf(value) !== -1,
    },
  },
  components: {
    BroadcastList,
  },
  computed: {
    disableNewBroadcast() {
      const trialEnded = this.$store.getters['AccountManager/trialEnded'];
      const subscriptionEnded = this.$store.getters['AccountManager/subscriptionEnded'];

      if (trialEnded || subscriptionEnded) {
        return true;
      }

      return false;
    },
  },
};
</script>
